var m = require('mithril');
var equipmentDetail = require('./equipmentDetail');
var equipmentDocuments = require('./equipmentDocuments');
var equipmentInspections = require('./equipmentInspections');
var equipmentCalibration = require('./equipmentCalibration');
var layout = require('../layout/layout');
var permissions = require('./permissions');

routes = {
  '/equipment/:equipmentClass/:id': {
    view: function() {
      return m(layout, m(equipmentDetail));
    },
  },
  '/equipment/:equipmentClass/:id/documents': {
    view: function() {
      return m(layout, m(equipmentDocuments));
    },
  },
  '/equipment/:equipmentClass/:id/inspection': {
    view: function() {
      return m(layout, m(equipmentInspections));
    },
  },
  '/equipment/:equipmentClass/:id/permissions': {
    view: function() {
      return m(layout, m(permissions));
    },
  },
  '/equipment/:equipmentClass/:id/calibration': {
    view: function() {
      return m(layout, m(equipmentCalibration));
    },
  },
}


module.exports = routes;